<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.BOXCODE"
        nolabel
        :placeholder="$t('search.boxcode')"
      ></m-input>
    </div>
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.BOXNAME"
        nolabel
        :placeholder="$t('search.boxname')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        BOXCODE: null,
        BOXNAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        BOXCODE: null,
        BOXNAME: null,
      };
    },
  },
};
</script>

<style></style>
